export default Date;

Date.prototype.explode = function () {
	return {
		Y: 	this.getFullYear(),
		n: 	this.getMonth() + 1,
		m:	(this.getMonth() + 1).toString().padStart(2, '0'),
		j: 	this.getDate(),
		d: 	this.getDate().toString().padStart(2, '0'),
		G: 	this.getHours(),
		H:	this.getHours().toString().padStart(2, '0'),
		i:	this.getMinutes().toString().padStart(2, '0'),
		s: 	this.getSeconds().toString().padStart(2, '0'),
		w: 	this.getDay()
	};
};

Date.prototype.format = function (format) {
	var r = '';
	var particles = this.explode();

	for (var i = 0; i < format.length; ++i) {
		if (Object.prototype.hasOwnProperty.call(particles, format[i])) {
			r += particles[format[i]];
		} else {
			r += format[i];
		}
	}

	return r;
};

Date.normDate = function (str) {
	const s = str.toString().substr(0, 19).replace(/-/g, '/');
	return new Date(s);
}

/**
 * Returns the week number for this date.  dowOffset is the day of week the week
 * "starts" on for your locale - it can be from 0 to 6. If dowOffset is 1 (Monday),
 * the week returned is the ISO 8601 week number.
 * @param int dowOffset
 * @return int
 */
 Date.prototype.getWeek = function (dowOffset) {
	/*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.epoch-calendar.com */
	
		dowOffset = typeof(dowOffset) == 'int' ? dowOffset : 0; //default dowOffset to zero
		var newYear = new Date(this.getFullYear(),0,1);
		var day = newYear.getDay() - dowOffset; //the day of week the year begins on
		day = (day >= 0 ? day : day + 7);
		var daynum = Math.floor((this.getTime() - newYear.getTime() - 
		(this.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
		var weeknum;
		//if the year starts before the middle of a week
		if(day < 4) {
			weeknum = Math.floor((daynum+day-1)/7) + 1;

			if(weeknum > 52) {
				var nYear	= new Date(this.getFullYear() + 1, 0, 1);
				var nday	= nYear.getDay() - dowOffset;
				nday		= nday >= 0 ? nday : nday + 7;
				/*if the next year starts before the middle of
				   the week, it is week #1 of that year*/
				weeknum = nday < 4 ? 1 : 53;
			}
		}
		else {
			weeknum = Math.floor((daynum+day-1)/7);
		}
		return weeknum;
	};